document.addEventListener('DOMContentLoaded', function() {
    let slideIndex = 0;
    const slides = document.querySelectorAll('.banner-section');
    const totalSlides = slides.length;

    function showSlide(index) {
        slides.forEach((slide, i) => {
            slide.classList.toggle('current', i === index);
        });
    }

    function nextSlide() {
        slideIndex = (slideIndex + 1) % totalSlides;
        showSlide(slideIndex);
    }

    showSlide(slideIndex); // Initial display
    setInterval(nextSlide, 10000); // Change slide every 10 seconds

    const infoIcon = document.querySelector('.info-icon');
    const tooltip = document.querySelector('.tooltip');

    // Function to determine if the device is a touchscreen
    function isTouchScreen() {
        return navigator.maxTouchPoints > 0; // Checks for touch capabilities
    }

    // Toggle tooltip display
    function toggleTooltip() {
        tooltip.style.display = (tooltip.style.display === 'block') ? 'none' : 'block';
    }

    // Close tooltip if clicking outside
    function closeTooltipOnOutsideClick(event) {
        if (!infoIcon.contains(event.target) && !tooltip.contains(event.target)) {
            tooltip.style.display = 'none'; // Hide the tooltip if clicking outside
        }
    }

    // Only add event listeners if the device is a touchscreen
    if (isTouchScreen()) {
        infoIcon.addEventListener('click', toggleTooltip);

        // Close tooltip when clicking outside
        document.addEventListener('click', closeTooltipOnOutsideClick);
    }

    // Optional: You can log or handle the case where it's not a touchscreen
    else {
        console.log("This device does not support touch events.");
    }
});
